import { useLocation } from '@tanstack/react-router'
import { useEffect } from 'react'

import { usePostHog } from './posthog-provider'

export function sanitizePageViewUrl(rawUrl: string) {
  const url = new URL(rawUrl)
  return `${url.origin}${url.pathname}`
}

export function usePageView() {
  const location = useLocation()
  const posthog = usePostHog()

  useEffect(() => {
    if (!posthog) {
      return
    }

    // Track page view
    posthog.capture('$pageview', {
      $current_url: sanitizePageViewUrl(window.location.href),
      pathname: location.pathname,
    })
  }, [location.pathname, posthog])
}
